import Cookies from 'js-cookie';
import { Session } from './session';
import { sessionCookieName } from '../const';

const isNullableString = (value: unknown): boolean => value === null || typeof value === 'string';

// `Session` (unlike the cookie's on-disk shape) deliberately carries no signedSessionId field -
// preserve whatever is currently on the cookie rather than silently dropping it on every
// client-side rewrite of this cookie (it's minted separately, see ensureSignedSessionIdClient.ts).
const readExistingSignedSessionId = (): string | null | undefined => {
  let signedSessionId: string | null | undefined;
  const existingRawCookie = Cookies.get(sessionCookieName);

  if (existingRawCookie !== undefined) {
    try {
      const parsedExisting: unknown = JSON.parse(existingRawCookie);
      if (typeof parsedExisting === 'object' && parsedExisting !== null) {
        const candidate = (parsedExisting as Record<string, unknown>).signedSessionId;
        if (isNullableString(candidate)) {
          signedSessionId = candidate as string | null | undefined;
        }
      }
    } catch {
      signedSessionId = undefined;
    }
  }

  return signedSessionId;
};

const createOrUpdateCsrSessionCookie = (session: Session): void => {
  if (typeof window !== 'undefined') {
    const isSecureContext = window.location.protocol === 'https:';
    const expires: Date = new Date();
    expires.setFullYear(expires.getFullYear() + 1);

    const signedSessionId = readExistingSignedSessionId();
    const authSessionCookie = JSON.stringify({ ...session, signedSessionId });
    Cookies.set(sessionCookieName, authSessionCookie, {
      expires,
      path: '/',
      sameSite: 'lax',
      secure: isSecureContext
    });
  }
};

export default createOrUpdateCsrSessionCookie;
